export { Query } from "./Query.js";
export { Mutation } from "./Mutation.js";
export { Subscription } from "./Subscription.js";
export * from "./types.js";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/react/components/index.js
// module id = 184
// module chunks = 17